import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { notificationApi } from "../service/notification-service";
import { notificationHubManager } from "../services/signalr/notification-hub-manager";
import { connectionError } from "../stores/slices/notification-slice";
import { AppDispatch, store } from "../stores/store";
import { isCustomer } from "../guards/common/authentification-functions";

export const useNotificationHub = () => {
	const dispatch = useDispatch<AppDispatch>();
	const hasInitialized = useRef(false);

		const negotiate = useCallback(
		() =>
			dispatch(
				notificationApi.endpoints.signalRNegotiate.initiate(undefined, { subscribe: false, forceRefetch: true })
			).unwrap(),
		[dispatch]
	);

	useEffect(() => {
		if (!isCustomer() || hasInitialized.current) return;

		// const negotiate = async () => {
		// 	const result = await store.dispatch(
		// 		notificationApi.endpoints.signalRNegotiate.initiate(undefined, { forceRefetch: true })
		// 	);
		// 	if (!('data' in result) || !result.data) throw new Error('SignalR negotiate failed');
		// 	return result.data;
		// };

		const initializeConnection = async () => {
			try {
				console.log("Initializing SignalR connection...");

				const result = await negotiate();

				const tokenFactory = async (): Promise<string> => {
					const fresh = await negotiate();
					return fresh.accessToken;
				};

				await notificationHubManager.initialize(result.url, tokenFactory);
				hasInitialized.current = true;
			} catch (error) {
				console.error("Failed to initialize SignalR connection:", error);
				dispatch(connectionError("Failed to negotiate connection"));
			}
		};

		initializeConnection();

		return () => {
			hasInitialized.current = false;
			notificationHubManager.stop();
		};
	}, []);
};
